/**
 * FAQ — accordion (onafhankelijk toggelen).
 *
 * Dunne wrapper op de gedeelde accordion-module (resources/js/accordion.js): dit
 * blok levert z'n eigen .faq__* selectors en het ONAFHANKELIJKE open-gedrag
 * (meerdere items mogen tegelijk open). Import in resources/js/main.js; self-init
 * op DOM-ready. De height-animatie + de visibility-fix (gesloten paneel uit de
 * tab-volgorde) zitten in de blok-scss.
 */
import { initAccordion } from '../../resources/js/accordion.js';

const CONFIG = {
    block: '.faq',
    item: '.faq__item',
    button: '.faq__question',
    openClass: 'faq__item--open',
    singleOpen: false,
};

/**
 * Initialiseert alle FAQ-blokken binnen een scope.
 *
 * @param {ParentNode} [scope] - Zoekwortel (default: document).
 */
export function initFaq(scope = document) {
    initAccordion(CONFIG, scope);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq());
} else {
    initFaq();
}
